import { render } from "./inviteCoupon.vue?vue&type=template&id=3f93a51c&scoped=true"
import script from "./inviteCoupon.vue?vue&type=script&lang=js"
export * from "./inviteCoupon.vue?vue&type=script&lang=js"

import "./inviteCoupon.vue?vue&type=style&index=0&id=3f93a51c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f93a51c"]])

export default __exports__